// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';

const root = ReactDOM.createRoot(document.getElementById('root'));

// src/index.js
root.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{
      onLoad: 'login-required',                                    
      // redirectUri: window.location.origin + '/landing-page', 
      // silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
      checkLoginIframe: false,                                
      pkceMethod: 'S256',
      silentCheckSsoFallback: true,   
    }}
  >
    <App />
  </ReactKeycloakProvider>
);

reportWebVitals();